var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { ReactComponent as BackrsFilledDropShadow } from '@backrs_ui/common-ui/src/assets/images/backrs-filled-drop-shadow.svg';
import { BackrsForm } from '@backrs_ui/common-ui/src/molecules/BackrsForm/BackrsForm';
import { Box, Typography, ButtonBase } from '@mui/material';
import { useForm } from 'react-hook-form';
import { LoginCarousel } from './LoginCarousel';
import { ForgotPasswordPopup } from '../BackrsForm/ForgotPasswordPopup';
var LOGIN_STRINGS = appStrings.modules.login;
var defaultLoginValues = {
    phone: '',
    email: '',
    password: '',
};
export function LoginPage(_a) {
    var _this = this;
    var title = _a.title, handleLoggingIn = _a.handleLoggingIn, handleSigningUp = _a.handleSigningUp, errorMessage = _a.errorMessage, environmentUrl = _a.environmentUrl;
    var _b = useState(false), isPasswordVisible = _b[0], setIsPasswordVisible = _b[1];
    var _c = useState(false), isForgotPasswordOpen = _c[0], setIsForgotPasswordOpen = _c[1];
    var methods = useForm({
        defaultValues: defaultLoginValues,
        mode: 'onSubmit',
        resolver: function (values) { return __awaiter(_this, void 0, void 0, function () {
            var errors;
            return __generator(this, function (_a) {
                errors = {};
                if (!values.phone && !values.email) {
                    errors.phone = {
                        type: 'manual',
                        message: LOGIN_STRINGS.error.phoneEmailRequired,
                    };
                }
                if (values.phone && !/^\d{10}$/.test(values.phone)) {
                    errors.phone = {
                        type: 'pattern',
                        message: LOGIN_STRINGS.error.invalidPhone,
                    };
                }
                if (values.email && !/^\S+@\S+$/.test(values.email)) {
                    errors.email = {
                        type: 'pattern',
                        message: LOGIN_STRINGS.error.invalidEmail,
                    };
                }
                if (values.email && !values.password && !values.phone) {
                    errors.password = {
                        type: 'required',
                        message: LOGIN_STRINGS.error.passwordRequired,
                    };
                }
                return [2, {
                        values: values,
                        errors: errors,
                    }];
            });
        }); },
    });
    var phoneValue = methods.watch('phone');
    var emailValue = methods.watch('email');
    var passwordValue = methods.watch('password');
    var fields = [
        {
            id: 'email',
            name: 'email',
            placeholder: LOGIN_STRINGS.emailPlaceholder,
            type: 'text',
            autoComplete: 'email',
            rules: {
                required: !phoneValue ? LOGIN_STRINGS.error.emailRequired : false,
                pattern: {
                    value: /^\S+@\S+\.\S+$/,
                    message: LOGIN_STRINGS.error.invalidEmail,
                },
            },
            disabled: !!phoneValue,
            autoFocus: true,
        },
        {
            id: 'password',
            name: 'password',
            placeholder: LOGIN_STRINGS.passwordPlaceholder,
            type: isPasswordVisible ? 'text' : 'password',
            autoComplete: 'current-password',
            rules: {
                required: !phoneValue ? LOGIN_STRINGS.error.passwordRequired : false,
            },
            icon: {
                type: 'RIGHT_ICON',
                rightIcon: isPasswordVisible ? 'EyeOff' : 'Eye',
                onRightIconClick: function () {
                    setIsPasswordVisible(function (prev) { return !prev; });
                    setTimeout(function () {
                        setIsPasswordVisible(false);
                    }, 5000);
                },
            },
            disabled: !!phoneValue,
            divider: true,
            dividerText: LOGIN_STRINGS.dividerText,
        },
        {
            id: 'phone',
            name: 'phone',
            placeholder: LOGIN_STRINGS.phonePlaceholder,
            type: 'tel',
            autoComplete: 'phone',
            rules: {
                pattern: {
                    value: /^\d{10}$/,
                    message: LOGIN_STRINGS.error.invalidPhone,
                },
            },
            disabled: !!emailValue && !!passwordValue,
        },
    ];
    var handleSubmission = function (data) {
        handleLoggingIn(data.phone, data.email, data.password);
    };
    return (_jsxs(Box, { sx: componentContainerSx, children: [_jsx(Box, { sx: containerStyle, children: _jsxs(Box, { sx: loginFormStyle, children: [_jsx(Box, { sx: responsiveBackrsLogoStyle, children: _jsx(BackrsFilledDropShadow, {}) }), _jsxs(Box, { sx: textContainerSx, children: [_jsx(Typography, { variant: "display-xs-semibold", color: function (theme) { return theme.backrs.colors['Colors/Text/text-primary']; }, children: title }), _jsx(Typography, { variant: "text-md-regular", color: function (theme) { return theme.backrs.colors['Colors/Text/text-tertiary']; }, sx: { textAlign: 'center' }, children: LOGIN_STRINGS.welcomeBack })] }), _jsx(BackrsForm, { fields: fields, methods: methods, onSubmit: handleSubmission, buttonLabel: appStrings.buttonText.signIn, children: _jsx(ButtonBase, { sx: forgotPasswordContainerStyle, onClick: function () { return setIsForgotPasswordOpen(true); }, disableRipple: true, children: _jsx(Typography, { variant: "text-sm-semibold", sx: forgotPasswordStyle, children: LOGIN_STRINGS.forgotPassword }) }) }), _jsx(ForgotPasswordPopup, { isOpen: isForgotPasswordOpen, setIsOpen: setIsForgotPasswordOpen, environmentUrl: environmentUrl }), errorMessage && _jsx(Box, { sx: errorMessageSx, children: errorMessage }), handleSigningUp && (_jsxs(Box, { sx: handleSignUpSx, children: [_jsx(Typography, { component: "span", variant: "text-sm-regular", children: LOGIN_STRINGS.dontHaveAccount }), ' ', _jsx(Typography, { component: "span", variant: "text-sm-regular", sx: embeddedButtonSx, onClick: handleSigningUp, children: LOGIN_STRINGS.signUp })] }))] }) }), _jsx(Box, { sx: carouselContainerSx, children: _jsx(LoginCarousel, {}) })] }));
}
var errorMessageSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        mt: 2,
        color: backrs.colors['Colors/Text/text-error-primary'],
        '@media (min-width: 900px) and (max-height: 620px)': {
            mt: '-2%',
            mb: '-5%',
        },
    });
};
var handleSignUpSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        paddingBottom: backrs.spacing['spacing-xl'],
    });
};
var embeddedButtonSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'inline',
        color: backrs.colors['Colors/Text/text-brand-tertiary'],
        cursor: 'pointer',
    });
};
var componentContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'grid',
        gridTemplateColumns: {
            xs: '1fr',
            md: '1fr 1fr',
        },
        color: backrs.colors['Yellow/950'],
        height: '100dvh',
        overflow: 'hidden',
    });
};
var carouselContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: {
            xs: 'none',
            md: 'block',
        },
        backgroundColor: backrs.colors['Colors/Foreground/fg-brand-secondary'],
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: 'center',
        width: '100%',
        height: '100dvh',
        borderLeft: "1px solid ".concat(backrs.colors['Colors/Base/Black']),
    });
};
var containerStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        margin: '0 auto',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: {
            xs: 'flex-start',
            md: 'center',
        },
        alignSelf: 'center',
        justifySelf: 'center',
        px: {
            xs: backrs.spacing['spacing-lg'],
            sm: backrs.spacing['spacing-2xl'],
        },
        backgroundColor: backrs.colors['Beige/50'],
        height: '100dvh',
        width: '100%',
        py: {
            xs: backrs.spacing['spacing-6xl'],
            md: backrs.spacing['spacing-4xl'],
        },
    });
};
var loginFormStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        backgroundColor: {
            xs: backrs.colors['Beige/50'],
            sm: backrs.colors['Colors/Base/White'],
        },
        paddingX: {
            xs: backrs.spacing['spacing-md'],
            sm: backrs.spacing['spacing-2xl'],
        },
        borderRadius: {
            xs: 0,
            sm: backrs.radius['radius-md'],
        },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: {
            xs: '100%',
            sm: '440px',
        },
        width: '100%',
        boxSizing: 'border-box',
        '@media (min-width: 300px)': {
            paddingX: backrs.spacing['spacing-xl'],
        },
        '@media (min-width: 600px)': {
            paddingX: backrs.spacing['spacing-4xl'],
        },
        boxShadow: {
            xs: 'none',
            sm: backrs.shadows['shadow-3xl'],
        },
        border: {
            xs: 'none',
            sm: "3px solid ".concat(backrs.colors['Colors/Base/Black']),
        },
        margin: {
            xs: 0,
            sm: "auto ".concat(backrs.spacing['spacing-4xl']),
            md: "auto ".concat(backrs.spacing['spacing-4xl']),
            lg: "auto ".concat(backrs.spacing['spacing-6xl']),
        },
        gap: {
            xs: backrs.spacing['spacing-3xl'],
            md: backrs.spacing['spacing-xl'],
        },
        pb: {
            xs: backrs.spacing['spacing-3xl'],
            md: backrs.spacing['spacing-4xl'],
        },
    });
};
var responsiveBackrsLogoStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        maxWidth: {
            xs: '50px',
            md: '60px',
        },
        maxHeight: {
            xs: '50px',
            md: '60px',
        },
        mt: backrs.spacing['spacing-3xl'],
    });
};
var forgotPasswordContainerStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'block',
        ml: 'auto',
        mr: backrs.spacing['spacing-md'],
    });
};
var forgotPasswordStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        color: backrs.colors['Brand/500'],
    });
};
var textContainerSx = function (theme) { return (__assign(__assign({}, loginFormStyle(theme)), { pb: 0, gap: '.5rem', outline: 'none', border: 'none', boxShadow: 'none' })); };
